module.exports = __webpack_public_path__ + "static/media/expandflip.81dd35d5.svg";